import { http } from '@/lib/api-client'
import type {
  Guardian,
  GuardianDetail,
  CreateGuardianInput,
  UpdateGuardianInput,
  GuardianListResponse,
  ListGuardiansParams,
} from './guardians.types'

// CRUD for guardians — /api/guardians. Branch-scoped by the lesson.
// list → full paginated envelope; single → unwrapped entity.
export const guardianApi = {
  list: (params?: ListGuardiansParams): Promise<GuardianListResponse> =>
    http.get<GuardianListResponse>('/guardians', { params }),

  getById: (id: string): Promise<GuardianDetail> =>
    http.get<{ data: GuardianDetail }>(`/guardians/${id}`).then((r) => r.data),

  create: (data: CreateGuardianInput): Promise<Guardian> =>
    http.post<{ data: Guardian }>('/guardians', data).then((r) => r.data),

  update: (id: string, data: UpdateGuardianInput): Promise<Guardian> =>
    http.patch<{ data: Guardian }>(`/guardians/${id}`, data).then((r) => r.data),

  delete: (id: string): Promise<void> => http.delete(`/guardians/${id}`),

  // POST /guardians/:id/verify-whatsapp — checks the number via the branch's
  // default WhatsApp session and persists the result.
  verifyWhatsapp: (
    id: string,
  ): Promise<{
    verified: boolean
    whatsappCheckedAt: string | null
    whatsappVerifiedAt: string | null
  }> =>
    http
      .post<{
        data: {
          verified: boolean
          whatsappCheckedAt: string | null
          whatsappVerifiedAt: string | null
        }
      }>(`/guardians/${id}/verify-whatsapp`)
      .then((r) => r.data),
}
